(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name commons.service:CommonMasterData
     *
     * @description
     *
     */
    angular
        .module('commons')
        .service('CommonMasterData', CommonMasterData);

    function CommonMasterData(RemoteService, EventManagerService, applicationConstants,CommonDataModel, MessageService,StorageServices) {
        var self = this;
        self.model = {
            crewTypeList: null,
            crewBaseTypes: null,
            employerHubList: null,
            crewGroups: null,
          offContracts: null,
            aircraftTypes: null,
            aircraftTypesList: null,
            aircraftModels: null,
            crewCategory: null,
          mgtPosition:null,
            aircrafts: null,
            airports: null,
            flights:null,
            delayCodeDetails: null,
            eventData: null,
            approachTypes: null,
            appWeekStartDay: 0, // for sunday
            pairingNames: null,
            trackingTimeZoneInfo: null,
            enableAeroOpsSystem:null,
            trainingPrograms: {},
            baseAirportCode: null,
            countryList: [],
            crewBatchList: null,
            crewAttributeList: null,
            nationalityList: null,
            languageList: null,
            crewTypeMasterCodes : null,
            trainingCategories:null,
            downloadCategories:null,
            alertCategories:null,
            roleNameList :null,
            validationTypes: null,
            privilageList:null,
            patternNamesByCrewType : [],
            undoProcessing:false,
            reportBaseUrl : null,
            tenant : null,
            reportParam : null,
            crewOperTypes :null,

            messageSentByList : null,
            messagePrioritiesList : null,
            messageStatusList : null,
            acarsMessageStatusList : null,
            messageUserNameList : null,
            messageCategoryList : null,
            msgStatusList : null,
            nonCrewUserList : null,
            responseStatusList : null,
            crewStatusList : null,
            dummyToken : null,
            missingReportStatusList:null,
            flightStatusList : null,
            divertedStatusList : null,
            acRegistrationList : null,
            leaveTypeList : null,
            designationList : null,
            aiportCategoriesList:null,
            monthsOfYear : null,
            yearList : null,
            reportPriviledgeMap : null,
            rightClickContextMenuPrivilegeMap : null,
            currency : null,
            passportParamValue : null,
            nextCommingFullScheduleList : null,
            fullScheduleListForRotationSummary : null,
            defaultMinGroundTime : null,
            trainingAuditViewByTypes :null,
            cabinFlightDelayCodes: null,
            acModelCrewReq: null,
            menusList: null,
            sectors:null,
            cosmicLimits:null,
            carriers:null,
            trainingProgramCode:null,
            trainingProgramDesc:null,
            trainingLocations:null,
            traineesList:null,
            trainersList:null,
            dropdownList: null,
            carriersList: null,
            ruleClassificationTypes: null,
            gdCarriersList: null,
            acmiTypes: null,
            defaultPasswordsList: null,
            crewDesignationList: null,
            departmentList:null
        };

        /**
         * getCrewTypeList
         * @param successFn
         * @param errorFn
         */
        self.getCrewTypeList = function (successFn, errorFn) {
            if (self.model.crewTypeList === null) {
                RemoteService.getCrewTypeList().then(
                    function (response) {
                        self.model.crewTypeList = response.crewTypeListDTOs;
                        successFn(self.model.crewTypeList);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.crewTypeList);
            }
        };


        self.getEmployerHubList = function (successFn, errorFn){
          if (self.model.employerHubList === null) {
            RemoteService.getHubs().then(
              function (response) {
                self.model.employerHubList = response;
                successFn(self.model.employerHubList);
              },
              function (error){
                errorFn(error.msg);
              }
            );
          } else {
            successFn(self.model.employerHubList);
          }
        };


        self.getCrewTypes = function () {
          return self.model.crewTypeList
        };

        self.getMessageSentByList = function (successFn, errorFn) {
          if (self.model.messageSentByList === null) {
            RemoteService.getMessageSentBy().then(
              function (response) {
                self.model.messageSentByList = response.messageSentByList;
                successFn(self.model.messageSentByList);
              },
              function (error) {
                errorFn(error.msg);
              }
            );
          } else {
            successFn(self.model.messageSentByList);
          }
        };

        self.getNonCrewUserList = function (successFn, errorFn) {
          if (self.model.nonCrewUserList === null) {
            RemoteService.searchNonCrewUsers().then(
              function (response) {
                self.model.nonCrewUserList = response.nonCrewUserList;
                successFn(self.model.nonCrewUserList);
              },
              function (error) {
                errorFn(error.msg);
              }
            );
          } else {
            successFn(self.model.nonCrewUserList);
          }
        };

        self.getMessagePrioritiesList = function (successFn, errorFn) {
          if (self.model.messagePrioritiesList === null) {
            RemoteService.getMessagePriorities().then(
              function (response) {
                self.model.messagePrioritiesList = response.messagePrioritesList;
                successFn(self.model.messagePrioritiesList);
              },
              function (error) {
                errorFn(error.msg);
              }
            );
          } else {
            successFn(self.model.messagePrioritiesList);
          }
        };

        self.searchStatusOfMsgs = function (successFn, errorFn) {
            if (self.model.msgStatusList === null) {
              RemoteService.searchStatusOfMsgs().then(
                function (response) {
                  self.model.msgStatusList = response.statusList;
                  successFn(self.model.msgStatusList);
                },
                function (error) {
                  errorFn(error.msg);
                }
              );
            } else {
              successFn(self.model.msgStatusList);
            }
          };

        self.getMessageStatusList = function (successFn, errorFn) {
          if (self.model.messageStatusList === null) {
            RemoteService.getMsgStatus().then(
              function (response) {
                self.model.messageStatusList = response.statusList;
                successFn(self.model.messageStatusList);
              },
              function (error) {
                errorFn(error.msg);
              }
            );
          } else {
            successFn(self.model.messageStatusList);
          }
        };

        self.getMessageCategoryList = function (successFn, errorFn) {
          if (self.model.messageCategoryList === null) {
            RemoteService.getMessageCategories().then(
              function (response) {
                self.model.messageCategoryList = response.messageCategoryList;
                successFn(self.model.messageCategoryList);
              },
              function (error) {
                errorFn(error.msg);
              }
            );
          } else {
            successFn(self.model.messageCategoryList);
          }
        };

        /**
         * get Gmt off Value
         * @param successFn
         * @param errorFn
         */
        self.getGmtOff = function (successFn, errorFn) {
        	 RemoteService.getGMTOffSetValue().then(
                     function (response) {
                         successFn(response.appParamValueDTO.paramValue);
                     },
                     function (error) {
                         errorFn(error.msg);
                     }
                 );
        };


        /**
         * get Default Min Ground Time
         * @param successFn
         * @param errorFn
         */
        self.getDefaultMinGroundTime = function (successFn, errorFn) {
        	if(!!self.model.defaultMinGroundTime){
        		successFn(self.model.defaultMinGroundTime);
        	} else {
        		RemoteService.getDefaultMinGroundTime().then(
                        function (response) {
                        	if(!!response.appParamValueDTO.paramValue){
                        		self.model.defaultMinGroundTime = Number(response.appParamValueDTO.paramValue);
                        		successFn(self.model.defaultMinGroundTime);
                        	} else {
                        		successFn(0);
                        	}

                        },
                        function (error) {
                            errorFn(error.msg);
                        }
                    );
        	}
        };

        self.getACModelCrewRequirement = function (successFn, errorFn) {
          if (self.model.acModelCrewReq === null) {
            RemoteService.getACModelCrewRequirement().then(
              function (response) {
                self.model.acModelCrewReq = response.aircraftModelCrewRequirementDTOCollection;
                successFn(self.model.acModelCrewReq);
              },
              function (error) {
                errorFn(error.msg);
              }
            );
          } else {
            successFn(self.model.acModelCrewReq);
          }
        };

        /**
         * get Currency
         * @param successFn
         * @param errorFn
         */
        self.getCurrency = function (successFn, errorFn) {
        	 RemoteService.getCurrency().then(
                     function (response) {
                         successFn(response.appParamValueDTO.paramValue);
                     },
                     function (error) {
                         errorFn(error.msg);
                     }
                 );
        };

        /**
         * get Show New GD
         * @param successFn
         * @param errorFn
         */
        self.getShowNewGD = function (successFn, errorFn) {
        	 RemoteService.getShowNewGDValue().then(
                     function (response) {
                         successFn((response.appParamValueDTO.paramValue == 'Y') ? true : false);
                     },
                     function (error) {
                         errorFn(error.msg);
                     }
                 );
        };

        /**
         * get Import Priviledge
         * @param successFn
         * @param errorFn
         */
        self.getImportPriviledges = function (successFn, errorFn) {
        	 RemoteService.getImportPriviledges().then(
                     function (response) {
                         successFn(response.importOtherHub);
                     },
                     function (error) {
                         errorFn(error.msg);
                     }
                 );
        };
      /***
       * get flight edit Priviledge
       * @param successFn
       * @param errorFn
       */

        self.getFlightEditPriviledge = function (successFn, errorFn) {
          RemoteService.getFlightEditPriviledge().then(
            function (response) {
              successFn(response);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        };

        /**
         * get Print Separate GD For Crew Types
         * @param successFn
         * @param errorFn
         */
        self.getPrintSeparateGDForCrewTypes = function (successFn, errorFn) {
        	 RemoteService.getPrintSeparateGDForCrewTypes().then(
                     function (response) {
                         successFn((response.appParamValueDTO.paramValue == 'Y') ? true : false);
                     },
                     function (error) {
                         errorFn(error.msg);
                     }
                 );
        };

        self.getPassportParamValue = function (successFn,errorFn) {
          RemoteService.getPassportParamValue().then(
            function (response) {
              successFn((response.appParamValueDTO.paramValue == 'Y') ? true : false);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        }

       self.getCivilIdStatus = function (successFn,errorFn) {
        RemoteService.civilIdStatus().then(
          function (response) {
            successFn((response.appParamValueDTO.paramValue == 'Y') ? true : false);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      }

      self.isShowSlotMessage = function (successFn, errorFn){
        RemoteService.isShowSlotMessage().then(
          function (response) {
            successFn((response.appParamValueDTO.paramValue == 'Y') ? true : false);
          },
          function (error) {
            errorFn(error);
          }
        );
      };
      self.isAutoPairingEnabled = function (successFn, errorFn){
        RemoteService.isAutoPairingEnabled().then(
          function (response) {
            successFn((response.appParamValueDTO.paramValue == 'Y') ? true : false);
          },
          function (error) {
            errorFn(error);
          }
        );
      };

      self.isShowMVTMessage = function (successFn, errorFn){
        RemoteService.isShowMVTMessage().then(
          function (response) {
            successFn((response.appParamValueDTO.paramValue == 'Y') ? true : false);
          },
          function (error) {
            errorFn(error);
          }
        );
      };

       self.isEnableRosterTabFromProfile = function (successFn,errorFn) {
           RemoteService.getEnableRosterTabFromProfile().then(
             function (response) {
               successFn((response.appParamValueDTO.paramValue == 'Y') ? true : false);
             },
             function (error) {
               errorFn(error.msg);
             }
           );
         }
        /**
         * getCrewBaseList
         * @param successFn
         * @param errorFn
         */
        self.getCrewBaseList = function (successFn, errorFn) {
            if (self.model.crewBaseTypes === null) {
                RemoteService.getBaseList().then(
                    function (response) {
                        self.model.crewBaseTypes = response.baseListDTOs;
                        self.model.crewBaseTypes = _.each(self.model.crewBaseTypes, function (obj) {
                            return obj.airPortCodeDecs = obj.airPortCode + " ";
                        });
                        successFn(self.model.crewBaseTypes);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.crewBaseTypes);
            }
        };

        self.getACMITypesList = function (successFn, errorFn) {
            if (self.model.acmiTypes === null) {
                RemoteService.getACMITypesList().then(
                    function (response) {
                        self.model.acmiTypes = response.acmiTypes;
                      /*  self.model.acmiTypes = _.each(self.model.crewBaseTypes, function (obj) {
                            return obj.airPortCodeDecs = obj.airPortCode + " ";
                        });*/
                        successFn(self.model.acmiTypes);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.acmiTypes);
            }
        };

      self.getManagementCrewPositions = function(successFn, errorFn){
        if(self.model.mgtPositions== null) {
          RemoteService.managementCrewPositions().then(
            function (response) {
              self.model.mgtPositions = response.managementCrewPositionList;
              successFn(self.model.mgtPositions);
            },
            function (error) {
              errorFn(error.msg[0]);
            }
          );
        }else{
          successFn(self.model.mgtPositions);
        }
      };

        /**
         * getAircraftTypeList
         * @param successFn
         * @param errorFn
         */
        self.getAircraftTypeList = function (successFn, errorFn) {
            if (self.model.aircraftTypesList === null) {
                RemoteService.getAircraftTypeList().then(
                    function (response) {
                        self.model.aircraftTypesList = response.aircraftTypeDTOs;
                        self.model.aircraftTypesList = _.each(self.model.aircraftTypesList, function (obj) {
                            return obj.modelNumberDecs = obj.modelNumber + " ";
                        });
                        successFn(self.model.aircraftTypesList);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.aircraftTypesList);
            }
        };

        /**
         * getAircraftTypeList
         * @param successFn
         * @param errorFn
         */
        self.getAircraftModels = function (successFn, errorFn) {
            if (self.model.aircraftTypes === null) {
                RemoteService.getAircraftModels().then(
                    function (response) {
                        self.model.aircraftTypes = response.aircraftTypeDTOs;
                        successFn(self.model.aircraftTypes);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.aircraftTypes);
            }
        };


      /**
       * getAircraftModelList
       * @param successFn
       * @param errorFn
       */
      self.getAircraftModelList = function (successFn, errorFn) {
        if (self.model.aircraftModels === null) {
          RemoteService.getAircraftModelList().then(
            function (response) {
              self.model.aircraftModels = response.aircraftModelDTOS;
              self.model.aircraftModels = _.each(self.model.aircraftModels, function (obj) {
                return obj.modelNumberDecs = obj.modelNumber + " ";
              });
              successFn(self.model.aircraftModels);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        } else {
          successFn(self.model.aircraftModels);
        }
      };
        /**
         * getCrewCategoryList
         * @param successFn
         * @param errorFn
         */
        self.getCrewCategoryList = function (successFn, errorFn) {
            if (self.model.crewCategory === null) {
                RemoteService.loadCrewCategoryList().then(
                    function (response) {
                        self.model.crewCategory = response.categories;
                        successFn(self.model.crewCategory);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.crewCategory);
            }
        };

      /**
       * getRuleClassificationTypes
       * @param successFn
       * @param errorFn
       */
      self.getRuleClassificationTypes = function (successFn, errorFn) {
        if (self.model.ruleClassificationTypes === null) {
          RemoteService.loadRuleClassificationTypes().then(
            function (response) {
              self.model.ruleClassificationTypes = response.ruleClassificationTypes;
              successFn(self.model.ruleClassificationTypes);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        } else {
          successFn(self.model.ruleClassificationTypes);
        }
      };

        /**
         * getMonthList
         * @param successFn
         * @param errorFn
         */
        self.getMonthList = function (successFn, errorFn) {
        	if (self.model.monthsOfYear === null) {
        		self.model.monthsOfYear = getMonths();
        		successFn(self.model.monthsOfYear);
        	} else {
        		successFn(self.model.monthsOfYear);
        	}
        };

        function getMonths(){
        	return Array.apply(0, Array(12)).map(
                    function(_,i){
                          var month    = {};
                          month.code   = parseInt(i+1);
                          month.desc   = moment().month(i).format('MMM');
                          return month;
                    }
              )
        }

        /**
         * getYearList
         * @param successFn
         * @param errorFn
         */
        self.getYearList = function (successFn, errorFn) {
        	if (self.model.yearList === null) {
        		var currentYear = parseInt(moment().format('YYYY'));
        		self.model.yearList = getYearList(currentYear - 10,currentYear + 10);
        		successFn(self.model.yearList);
        	} else {
        		successFn(self.model.yearList);
        	}
        };

        function getYearList(start, end) {
            var years = [];
            for (var i = start; i <= end; i++) {
            	var year = {};
            	year.code = i;
            	year.desc = i;
            	years.push(year);
            }
            return years;
        }

        /**
         * Get Crew Type Master Codes
         * @param successFn
         * @param errorFn
         */
        self.getCrewTypeMasterCodes = function (successFn, errorFn) {
            if (self.model.crewTypeMasterCodes === null) {
                RemoteService.getCrewTypeMasterCodes().then(
                    function (response) {
                        self.model.crewTypeMasterCodes = response.crewTypeMasterCodeList;
                        successFn(self.model.crewTypeMasterCodes);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.crewTypeMasterCodes);
            }
        }

        /**
         * getAircraftList
         * @param successFn
         * @param errorFn
         */
        self.getAircraftList = function (param, successFn, errorFn) {
            if (self.model.aircrafts === null) {
                RemoteService.loadAircraftList(param).then(
                    function (response) {
                        self.model.aircrafts = response.aircrafts;
                        successFn(self.model.aircrafts);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.aircrafts);
            }
        };

        /**
         * getAirportList
         * @param successFn
         * @param errorFn
         */
        self.getAirportList = function (successFn, errorFn) {
          RemoteService.loadAirportList().then(
            function (response) {
              self.model.airports = response.airPortListDTOs;
              successFn(self.model.airports);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        };

      self.getFlights = function (param, successFn, errorFn) {
          RemoteService.getFlights(param).then(
            function (response) {
              self.model.flights = response;
              successFn(self.model.flights);
            },
            function (error) {
              errorFn(error.msg);
            }
          );

      };

        self.formatAirportList = function (airPortList) {
            var fAirportList = [{
                airPortCode:null,
                airPortName:"ANY "
            }];
            _.each(airPortList, function (ap) {
                fAirportList.push({
                    airPortCode: ap.airPortCode,
                    airPortName: ap.airPortCode + " "
                });
            });
            return fAirportList;
        };


        /**
         * Get Crew Groups Helper function
         * @param successFn
         * @param errorFn
         */
        self.getCrewGroups = function (successFn, errorFn) {
            if (self.model.crewGroups == null) {
                RemoteService.getCrewGroups().then(
                    function (response) {
                        self.model.crewGroups = response;
                        successFn(self.model.crewGroups);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.crewGroups);
            }
        };

      /**
       * Get Crew Groups Helper function
       * @param successFn
       * @param errorFn
       */
      self.getOffContracts = function (successFn, errorFn) {
        if (self.model.offContracts == null) {
          RemoteService.getOffContracts().then(
            function (response) {
              self.model.offContracts = response;
              successFn(self.model.offContracts);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        } else {
          successFn(self.model.offContracts);
        }
      };

        /**
         *
         * @param successFn
         * @param errorFn
         */
        self.getDelayCodeDetails = function (successFn, errorFn) {
            if (self.model.delayCodeDetails == null) {
                RemoteService.getDelayCodeDetails().then(
                    function (response) {
                        self.model.delayCodeDetails = response;
                        successFn(self.model.delayCodeDetails);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.delayCodeDetails);
            }
        };

        self.getFlightOperationTypes = function (successFn, errorFn) {
          RemoteService.getFlightOperationTypes().then(
            function (response) {
              self.model.operationTypes = response;
              successFn(self.model.operationTypes)
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        };

        /**
         * Get Training Program Details by Training Program
         * @param program
         * @param successFn
         * @param errorFn
         */
        self.getTrainingProgramDetails = function (program, successFn, errorFn) {
              RemoteService.loadTrainingProgramDetails(program.trainingProgramId).then(
                  function (response) {
                      if (response.success) {
                          if (response.hasOwnProperty('trainingProgDetailDTOs')) {
                              self.model.trainingPrograms[program.trainingProgramId] = response.trainingProgDetailDTOs;
                              successFn(self.model.trainingPrograms[program.trainingProgramId]);
                           }
                        }
                   },
                    function (error) {
                     errorFn(error);
                   }
              );
        };




        /**
         * Get Training Program by Training
         * @param training
         * @param successFn
         * @param errorFn
         */
        self.getTrainingProgram = function (training, successFn, errorFn) {
            RemoteService.loadTrainingProgram(training.trainingSlotId).then(
                function (response) {
                    if (response.success) {
                        if (response.hasOwnProperty('trainingProgramDTOs')) {
                            successFn(response.trainingProgramDTOs);
                        }
                    }
                },
                function (error) {
                    errorFn(error);
                }
            );
        };


      self.getSnapShotsBYCycleId = function (cycleId, successFn, errorFn) {
        RemoteService.getSnapShotsByCycleId(cycleId).then(
          function (response) {
            if (response.success) {
              if (response.hasOwnProperty('dataList')) {
                successFn(response.dataList);
              }
            }
          },
          function (error) {
            errorFn(error);
          }
        );
      };


      self.getScoringVersionByCycleIdAndCrewType = function (cycleId,crewType, successFn, errorFn) {
        RemoteService.getScoringVersionByCycleIdAndCrewType(cycleId,crewType).then(
          function (response) {
            if (response.success) {
              if (response.hasOwnProperty('dataList')) {
                successFn(response.dataList);
              }
            }
          },
          function (error) {
            errorFn(error);
          }
        );
      };



      /**
       * Search Training
         * @param requestTrainingData
         * @param successFn
         * @param errorFn
         */
        self.searchPairingForTrainings = function (requestTrainingData, successFn, errorFn) {
            RemoteService.loadTrainingForPairing(requestTrainingData).then(
                function (response) {
                    var resObj = adaptTrainingResponse(response);
                    successFn(resObj);
                },
                function (error) {
                    errorFn(error);
                });
        };

        /**
         * Search Events
         * @param requestEventsData
         * @param successFn
         * @param errorFn
         */
        self.searchEvents = function (requestEventsData, successFn, errorFn) {
            if (self.model.eventData !== null) {
                successFn(self.model.eventData);
            } else {
                RemoteService.loadEventsForPairing(requestEventsData).then(
                    function (response) {
                        if (response.success) {
                            if (response.hasOwnProperty('eventViewDTOs')) {
                                self.model.eventData = _.filter(response.eventViewDTOs, function (obj) {
                                    return obj.usedInPatterns === true;
                                });
                                self.model.eventData = _.each(self.model.eventData, function (obj) {
                                    return obj.eventDescription = obj.eventDescription + " ";
                                });
                                successFn(self.model.eventData);
                            }
                        }
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            }
        };

        /**
         * Get Memo Categories Helper function
         * @param successFn
         * @param errorFn
         */
        self.getMemoCategories = function (successFn, errorFn) {
            RemoteService.getMemoCategories().then(
                function (response) {
                    successFn(getMemoCategoriesAdaptor(response));
                },
                function (error) {
                    errorFn(error);
                }
            )
        };

        /**
         * Adept Training response
         * @param responseObj
         * @returns {Array}
         */
        function adaptTrainingResponse(responseObj) {
            var toSend = [];
            if (responseObj.hasOwnProperty('trainingResponseDTOs') && responseObj.trainingResponseDTOs.length > 0) {
                toSend = responseObj.trainingResponseDTOs;
            }
            else {
                MessageService.warning(MessageService.MESSAGES.CREATE_PAIRING.NO_TRAINING_FOUND);
            }
            return toSend;
        }

        self.approachTypes = function (successFn, errorFn) {
            if (self.model.approachTypes === null) {
                RemoteService.loadApproachTypes().then(
                    function (response) {
                        self.model.approachTypes = response.approachTypeDTOs;
                        successFn(self.model.approachTypes);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.approachTypes);
            }
        };

        self.crewOperTypes = function (successFn, errorFn) {
            if (self.model.crewOperTypes === null) {
                RemoteService.loadCrewOperTypes().then(
                    function (response) {
                        self.model.crewOperTypes = response.operTypes;
                        successFn(self.model.crewOperTypes);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.crewOperTypes);
            }
        };

        self.getTrainingAuditViewByTypes =  function (successFn, errorFn) {
            if (self.model.trainingAuditViewByTypes === null) {
                RemoteService.getTrainingAuditViewByTypes().then(
                    function (response) {
                        self.model.trainingAuditViewByTypes = response.types;
                        successFn(self.model.trainingAuditViewByTypes);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.trainingAuditViewByTypes);
            }
        };

        self.getPairingNames = function (obj, successFn, errorFn) {
            RemoteService.loadPatternNames(obj.fromDate, obj.toDate).then(
                function (response) {
                    self.model.pairingNames = response.patternNames;
                    successFn(self.model.pairingNames);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        self.getRosterPairingNames = function (obj, successFn, errorFn) {
          RemoteService.loadRosterPatternNames(obj.cycleId, obj.crewType).then(
            function (response) {
              successFn(response.patternNames);
            },
            function (error) {
              errorFn(error.msg);
            }
          )
        }

        /**
         * Get Tracking
         * @param successFn
         * @param errorFn
         */
        self.getTrackingTimeZone = function (successFn, errorFn) {
            if (self.model.trackingTimeZoneInfo !== null) {
                successFn(self.model.trackingTimeZoneInfo);
            } else {
                RemoteService.getTrackingTimeZone().then(
                    function (response) {
                        self.model.trackingTimeZoneInfo = response.appParamValueDTO;
                        successFn(self.model.trackingTimeZoneInfo);
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            }
        };

      self.getAeroOpsEnableParam = function (successFn, errorFn) {
        if (self.model.enableAeroOpsSystem !== null) {
          successFn(self.model.enableAeroOpsSystem);
        } else {
          RemoteService.getAeroOpsEnableParam().then(
            function (response) {
              self.model.enableAeroOpsSystem = response.appParamValueDTO;
              successFn(self.model.enableAeroOpsSystem);
            },
            function (error) {
              errorFn(error);
            }
          );
        }
      };


        /**
         * getCrewList
         * @param successFn
         * @param errorFn
         */
        self.loadCrewList = function (param, successFn, errorFn) {
            RemoteService.loadCrewList(param).then(
                function (response) {
                    successFn(response.crewList);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        self.loadEmployerHubList = function (param,successFn,errorFn){
          RemoteService.loadEmployerHubList(param).then(
            function (response){
              successFn(response.employerHubList);
            },
            function (error){
              errorFn(error.msg);
            }
          );
        };

      self.loadRosterCrewList = function (param, successFn, errorFn) {
        RemoteService.loadRosterCrewList(param).then(
          function (response) {
            successFn(response.crewList);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      };

      self.loadInstructorList = function (successFn, errorFn) {
        RemoteService.loadInstructorList().then(
          function (response) {
            successFn(response.crewList);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      };

      self.loadAirlineList = function (ownAirline,successFn, errorFn) {
        RemoteService.loadAirlineList(ownAirline).then(
          function (response) {
            successFn(response.airlineList);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      };

      self.getLeaveTypeList = function (successFn, errorFn) {
        if (self.model.leaveTypeList === null) {
          RemoteService.searchLeaveTypeList().then(
            function (response) {
              self.model.leaveTypeList = response.eventViewDTOs;
              successFn(self.model.leaveTypeList);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        } else {
          successFn(self.model.leaveTypeList);
        }
      };

      self.getAiportCategoriesList = function (successFn, errorFn) {
        if (self.model.aiportCategoriesList === null) {
          RemoteService.searchAiportCategoriesList().then(
            function (response) {
              self.model.aiportCategoriesList = response.airportCategories;
              successFn(self.model.aiportCategoriesList);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        } else {
          successFn(self.model.aiportCategoriesList);
        }
      };


        self.getAppWeekStartDay = function () {
            return self.model.appWeekStartDay;
        };

        /**
         * loadValidationList
         * @param successFn
         * @param errorFn
         */
        self.loadValidationList = function (param, successFn, errorFn) {
            RemoteService.loadValidations(param).then(
                function (response) {
                    successFn(response.validationCollection);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        /**
         * load Application Parameter List
         * @param successFn
         * @param errorFn
         */
        self.loadAppParamList = function (param, successFn, errorFn) {
            RemoteService.loadAllAppParamList(param).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        /**
         * loadACTypesByValidationList
         * @param successFn
         * @param errorFn
         */
        self.loadACTypesByValidationList = function(param,successFn, errorFn){
			RemoteService.getACTypesByValidation(param).then(
			function(response) {
				successFn(response);
			}, function(error) {
				errorFn(error)
			})
        };

        self.getAppWeekStartDay = function () {
            return self.model.appWeekStartDay;
        };

        /**
         * Get Trainer Trainee types
         * @param crewProfileId
         * @param trainingProgramId
         * @param successFn
         * @param errorFn
         */
        self.getTrainerTraineeTypes = function (crewProfileId, trainingProgramId, selectedTrainingSlotId, startTimeTraining, crewId, successFn, errorFn) {
            RemoteService.getTrainerTraineeTypes(crewProfileId, trainingProgramId, selectedTrainingSlotId, startTimeTraining, crewId).then(
                function (response) {
                    successFn(response.trainerTypeList);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

      self.getTrainerTraineeCourses = function (crewProfileId, trainingProgramId, crewId, successFn, errorFn) {
        if (typeof crewId === 'function') {
          errorFn = successFn;
          successFn = crewId;
          crewId = '0';  // Default placeholder when not provided
        }
        
        var effectiveCrewId = (crewId && crewId !== 'null' && crewId.toString().trim() !== '') ? crewId : '0';
        
        RemoteService.getTrainerTraineeCourses(crewProfileId, trainingProgramId, effectiveCrewId).then(
          function (response) {
            successFn(response.trainerCourseList);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      };

      // otherHub should be the exact hub tag (e.g. crew.otherHub) already present on the specific
      // deduplicated crew entry being displayed - null/undefined means that entry is native.
      self.getTrainerTraineeCoursesForHub = function (crewProfileId, trainingProgramId, crewId, otherHub, successFn, errorFn) {
        var effectiveCrewId = (crewId && crewId !== 'null' && crewId.toString().trim() !== '') ? crewId : '0';
        var effectiveOtherHub = (otherHub && otherHub !== 'null' && otherHub.toString().trim() !== '') ? otherHub : 'NONE';

        RemoteService.getTrainerTraineeCoursesForHub(crewProfileId, trainingProgramId, effectiveCrewId, effectiveOtherHub).then(
          function (response) {
            successFn(response.trainerCourseList);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      };

        self.getRuleDescList = function (isHard, successFn, errorFn) {
            RemoteService.getRuleDescList(isHard).then(
                function (response) {
                    successFn(response.rules);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

//        getCurrent time based on time zone
        self.getCurrentTime = function (timeZone, successFn, errorFn) {

            RemoteService.loadCurrentTime(timeZone).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );

        };

        /**
         * Get Base airport helper service
         * @param successFn
         * @param errorFn
         */
        self.getBaseAirport = function (successFn, errorFn) {
            if (!!self.model.baseAirportCode) {
                successFn(self.model.baseAirportCode);
            } else {
                RemoteService.getBaseAirport().then(
                    function (response) {
                        if (response.success) {
                            successFn(response.baseAirportCode);
                        }
                    },
                    function (error) {
                        errorFn(error);
                    }
                )
            }
        };
        /**
         * Get country list
         * @param successFn
         * @param errorFn
         */
        self.getCountryList = function (successFn, errorFn) {
            if (!!self.model.countryList && self.model.countryList.length>0 ) {
                successFn(self.model.countryList);
            }
            else {
                RemoteService.loadCountryList().then(
                    function (response) {
                        self.model.countryList = response.countryCollection;
                        successFn(self.model.countryList);
                    },
                    function (error) {
                        errorFn(error.msg)
                    }
                )
            }
        };

        /**
         * Get Crew Batch Types List
         * @param param
         * @param successFn
         * @param errorFn
         */
        self.getCrewBatchList = function (param, successFn, errorFn) {
            if (!!self.model.crewBatchList) {
                successFn(self.model.crewBatchList);
            }
            else {
                RemoteService.loadCrewBatchList(param).then(
                    function (response) {
                        self.model.crewBatchList = response.batchList;
                        successFn(self.model.crewBatchList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

        /**
         * Get Crew Attribute List
         * @param param
         * @param successFn
         * @param errorFn
         */
        self.getCrewAttributeList = function (param, successFn, errorFn) {
            if (!!self.model.crewAttributeList) {
                successFn(self.model.crewAttributeList);
            }
            else {
                RemoteService.loadCrewAttributeList(param).then(
                    function (response) {
                        self.model.crewAttributeList = response.batchList;
                        successFn(self.model.crewAttributeList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

        /**
         * load Pattern Name List By Crew Type Code
         * @param param
         * @param successFn
         * @param errorFn
         */
        self.loadPatternNameListByCrewTypeCode = function (param, successFn, errorFn) {
            if (!!param) {
            	RemoteService.loadPatternNamesByCrewTypeCode(param).then(
                        function (response) {
                            if(response.success){
                            	self.model.patternNamesByCrewType = response.patternNames;
                            }else{
                            	self.model.patternNamesByCrewType = [];
                            }
                            successFn(self.model.patternNamesByCrewType);
                        },
                        function (error) {
                            errorFn(error)
                        }
                    )
            }else{
            	self.model.patternNamesByCrewType = [];
            }
        };

        /**
         * Get nationality list
         * @param successFn
         * @param errorFn
         */
        self.getNationalityList = function (successFn, errorFn) {
            if (!!self.model.nationalityList) {
                successFn(self.model.nationalityList);
            }
            else {
                RemoteService.loadNationalityList().then(
                    function (response) {
                        self.model.nationalityList = response.nationalities;
                        successFn(self.model.nationalityList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };


        /**
         *
         */

        self.getRoleNameList = function (successFn, errorFn) {
            if (!!self.model.roleNameList) {
                successFn(self.model.roleNameList);
            }
            else {
                RemoteService.loadRoleNameList().then(
                    function (response) {
                        self.model.roleNameList = response.roles;
                        successFn(self.model.roleNameList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

      self.getUpdatedRoleNameList = function (successFn, errorFn) {
          RemoteService.loadRoleNameList().then(
            function (response) {
              self.model.roleNameList = response.roles;
              successFn(self.model.roleNameList);
            },
            function (error) {
              errorFn(error)
            }
          )
      };

        /**
         * @param successFn
         * @param errorFn
         */

        self.getPrivilageList = function (successFn, errorFn) {
            if (!!self.model.privilageList) {
                successFn(self.model.privilageList);
            }
            else {
                RemoteService.loadPrivilageList().then(
                    function (response) {
                        self.model.privilageList = response.categories;
                        successFn(self.model.privilageList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

        /**
         * @param successFn
         * @param errorFn
         */

        self.loadMenu = function (successFn, errorFn) {
            if (!!self.model.menuList) {
                successFn(self.model.menuList);
            }
            else {
                RemoteService.loadMenu().then(
                    function (response) {
                        self.model.menuList = response.mainMenus;
                        successFn(self.model.menuList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

        /**
         * Get Language list
         * @param successFn
         * @param errorFn
         */
        self.getLanguageList = function (successFn, errorFn) {
            if (!!self.model.languageList) {
                successFn(self.model.languageList);
            }
            else {
                RemoteService.loadLanguageList().then(
                    function (response) {
                        self.model.languageList = response.languageList;
                        successFn(self.model.languageList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

        self.getDefaultPasswords = function (successFn, errorFn) {
            if (!!self.model.defaultPasswordsList) {
                successFn(self.model.defaultPasswordsList);
            }
            else {
                RemoteService.getDefaultPasswords().then(
                    function (response) {
                        self.model.defaultPasswordsList = response;
                        successFn(self.model.defaultPasswordsList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

        /**
         * Get Response Status list
         * @param successFn
         * @param errorFn
         */
        self.getResponseStatusList = function (successFn, errorFn) {
            if (!!self.model.responseStatusList) {
                successFn(self.model.responseStatusList);
            }
            else {
                RemoteService.loadResponseStatusList().then(
                    function (response) {
                        self.model.responseStatusList = response.responseStatusList;
                        successFn(self.model.responseStatusList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

        /**
         *
         */
        self.getMissingReportStatusList  = function (successFn, errorFn) {
            if (!!self.model.missingReportStatusList) {
                successFn(self.model.missingReportStatusList);
            }
            else {
                RemoteService.getMissingReportStatusList().then(
                    function (response) {
                        self.model.missingReportStatusList = response.missingReportStatus;
                        successFn(self.model.missingReportStatusList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };
        self.getFlightStatusList  = function (successFn, errorFn) {
            if (!!self.model.flightStatusList) {
                successFn(self.model.flightStatusList);
            }
            else {
                RemoteService.getFlightStatusList().then(
                    function (response) {
                        self.model.flightStatusList = response.flightStatusList;
                        successFn(self.model.flightStatusList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

        self.getDivertedStatusList  = function (successFn, errorFn) {
            if (!!self.model.divertedStatusList) {
                successFn(self.model.divertedStatusList);
            } else {
                RemoteService.getDivertedStatusList().then(
                    function (response) {
                        self.model.divertedStatusList = response.divertedStatusList;
                        successFn(self.model.divertedStatusList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

        self.getAcRegistrationList  = function (successFn, errorFn) {
            if (!!self.model.acRegistrationList) {
                successFn(self.model.acRegistrationList);
            } else {
                RemoteService.getAcRegistrationList().then(
                    function (response) {
                        self.model.acRegistrationList = response.acRegistrationList;
                        successFn(self.model.acRegistrationList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

        /**
         * Get Response Status list
         * @param successFn
         * @param errorFn
         */
        self.getCrewStatusList = function (successFn, errorFn) {
            if (!!self.model.crewStatusList) {
                successFn(self.model.crewStatusList);
            }
            else {
                RemoteService.loadCrewStatusList().then(
                    function (response) {
                        self.model.crewStatusList = response.responseStatusList;
                        successFn(self.model.crewStatusList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

        /**
         * getAlertCategoryList
         * @param successFn
         * @param errorFn
         */
        self.getAlertCategoryList = function (successFn, errorFn) {
            if (self.model.alertCategories === null) {
                RemoteService.getAlertCategories().then(
                    function (response) {
                        self.model.alertCategories = response.categoryList;
                        self.model.alertCategories = _.each(self.model.alertCategories, function (obj) {
                            return obj.categoryDescription = obj.categoryCode + " ";
                        });
                        successFn(self.model.alertCategories);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.alertCategories);
            }
        };

        /**
         * getValidationTypeList
         * @param successFn
         * @param errorFn
         */
        self.getValidationTypeList = function (successFn, errorFn) {
        	//if validation types are not loaded
            if (self.model.validationTypes === null) {
                RemoteService.getValidationTypes().then(
                    function (response) {
                    	self.model.validationTypes = response.validationTypeCollection;
                        successFn(self.model.validationTypes);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
            } else {
                successFn(self.model.validationTypes);
            }
        };

        /**
         * Get Training  Categories
         * @param successFn
         * @param errorFn
         */
        self.getTrainingCategories= function (successFn, errorFn) {
            if (!!self.model.trainingCategories) {
                successFn(self.model.trainingCategories);
            }
            else {
                RemoteService.loadTrainingCategories().then(
                    function (response) {
                        self.model.trainingCategories = response.trainingCategoryList;
                        successFn(self.model.trainingCategories);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

      /***
       * get sectors
       * @param successFn
       * @param errorFn
       */
        self.getSectors= function (successFn, errorFn) {
          if (!!self.model.sectors) {
            successFn(self.model.sectors);
          }
          else {
            RemoteService.getSectors().then(
              function (response) {
                self.model.sectors = response.sectors;
                successFn(self.model.sectors);
              },
              function (error) {
                errorFn(error)
              }
            )
          }
        };

      /***
       * get cosmic exposure limits
       *
       */
      self.getExposureLimits= function (successFn, errorFn) {
        if (!!self.model.cosmicLimits) {
          successFn(self.model.cosmicLimits);
        }
        else {
          RemoteService.getCosmicExposureLimits().then(
            function (response) {
              self.model.cosmicLimits = response.exposureLimits;
              successFn(self.model.cosmicLimits);
            },
            function (error) {
              errorFn(error)
            }
          )
        }
      };

      /**
       * Get All Training  Categories
       * @param successFn
       * @param errorFn
       */
      self.getAllTrainingCategories= function (successFn, errorFn) {
        if (!!self.model.trainingCategories) {
          successFn(self.model.trainingCategories);
        }
        else {
          RemoteService.loadAllTrainingCategories().then(
            function (response) {
              self.model.trainingCategories = response.trainingCategoryList;
              successFn(self.model.trainingCategories);
            },
            function (error) {
              errorFn(error)
            }
          )
        }
      };

        /**
         * Get Designations
         * @param successFn
         * @param errorFn
         */
        self.getDesignations = function (successFn, errorFn) {
            if (!!self.model.designationList) {
                successFn(self.model.designationList);
            }
            else {
                RemoteService.getDesignations().then(
                    function (response) {
                        self.model.designationList = response.designationDTOs;
                        successFn(self.model.designationList);
                    },
                    function (error) {
                        errorFn(error)
                    }
                )
            }
        };

      self.getIsNightForNightCreditEnable = function (successFn, errorFn){
        RemoteService.getNightFlyForNightCredit().then(
          function (response) {
            successFn((response.appParamValueDTO.paramValue == 'Y'));
          },
          function (error) {
            errorFn(error);
          }
        );
      };

        self.getNewAlertMsgCount = function(successFn, errorFn){
			RemoteService.getNewAlertMsgCount().then(function(response) {
				successFn(response.newAlertMsgCount);
			}, function(error) {
				errorFn(error)
			})
        }


      self.getCommanderDiscReptCount = function(successFn, errorFn){
        RemoteService.getCommanderDiscReptCount().then(function(response) {
          successFn(response.reportCount);
        }, function(error) {
          errorFn(error)
        })
      }

        self.searchUserTypes = function(successFn, errorFn){
			RemoteService.searchUserTypes().then(function(response) {
				successFn(response.userTypes);
			}, function(error) {
				errorFn(error)
			})
        }

        self.getDownloadCategoryList = function (successFn, errorFn) {
            if (!!self.model.downloadCategories) {
                successFn(self.model.downloadCategories);
            }else{
                RemoteService.loadAllDownloadCategory().then(
                    function (response) {
                        self.model.downloadCategories = [];
                        _.each(response, function (cat) {
                            self.model.downloadCategories.push({
                                categoryCode:cat.categoryCode,
                                categoryDesc:cat.categoryDesc
                            });
                        });
                        successFn(self.model.downloadCategories);
                    },function (error) {
                        errorFn(error)
                    }
                );
            }
        };

        self.undoAction = function (successFn) {
            if(!self.model.undoProcessing){
                self.model.undoProcessing=true;
                RemoteService.undoAction().then(
                    function (response) {
                        if(response.success){
                            successFn(response.crewIds || []);
                            self.model.undoProcessing=false;
                            if(response.messages!==null && response.messages.length>0){
                                var msgString="";
                                angular.forEach(response.messages, function (msg) {
                                    msgString += msg +'\n';
                                });
                                MessageService.warning(msgString);
                            }
                            if(response.warnings!==null && response.warnings.length>0){
                                var msgString="";
                                angular.forEach(response.warnings, function (msg) {
                                    msgString += msg +'\n';
                                });
                                MessageService.warning(msgString);
                            }
                        }
                    },
                    function (error) {
                        self.model.undoProcessing=false;
                        MessageService.error(error);
                    }
                );
            }
        };

        self.getReportServerBaseUrl = function(){
        	if(self.model.reportBaseUrl == null){
	        	RemoteService.getReportServerBaseUrl().then(
	                    function (response) {
	                    	self.model.reportBaseUrl = response.baseUrl;
                        return self.model.reportBaseUrl;
	                    },function (error) {}
	             );
        	}
        	return self.model.reportBaseUrl;
        }

        self.getTenant = function(successFn,errorFn){
        	if(self.model.tenant == null){
	        	RemoteService.getTenant().then(
	                    function (response) {
	                    	self.model.tenant = response.tenant;
	                    	successFn(self.model.tenant);
	                    },function (error) {
	                        errorFn(error)
	                    }
	             );
        	}else{
        		successFn(self.model.tenant);
        	}
        }

        self.getReportBaseUrl = function (successFn, errorFn) {
            RemoteService.getReportServerBaseUrl().then(
              function (response) {
            	self.model.reportBaseUrl = response.baseUrl;
                successFn(self.model.reportBaseUrl);
              },
              function (error) {
                errorFn(error.msg);
              }
            );
          };


        self.getReportPriviledges = function(successFn,errorFn){
        	if(!!self.model.reportPriviledgeMap){
        		successFn(self.model.reportPriviledgeMap);
        	}else{
        		RemoteService.getReportPriviledges().then(
	                    function (response) {
	                    	self.model.reportPriviledgeMap = response.reportCategoryPriviledgeMap;
	                    	successFn(self.model.reportPriviledgeMap);
	                    },function (error) {
	                        errorFn(error)
	                    }
	             );
        	}
        }

      self.getRightClickContextMenuPrivileges = function(successFn,errorFn){
        if(!!self.model.rightClickContextMenuPrivilegeMap){
          successFn(self.model.rightClickContextMenuPrivilegeMap);
        }else{
          RemoteService.getRightClickContextMenuPrivileges().then(
            function (response) {
              self.model.rightClickContextMenuPrivilegeMap = response.rightClickContextMenuPriviledgeMap;
              successFn(self.model.rightClickContextMenuPrivilegeMap);
            },function (error) {
              errorFn(error)
            }
          );
        }
      };

        self.getRightClickLeaveAssignmentOptions = function(successFn, errorFn) {
          RemoteService.getLeaveAssignmentRightClickOptions().then(
            function (response) {
              successFn(response)
            }, function (error) {
              errorFn(error.msg)
            }
          );
        };

      self.getRightClickEventAssignmentOptions = function(successFn, errorFn) {
        RemoteService.getEventAssignmentRightClickOptions().then(
          function (response) {
            successFn(response)
          }, function (error) {
            errorFn(error.msg)
          }
        );
      };

      self.getNextCommingFullScheduleList = function(successFn,errorFn){
        if(!!self.model.nextCommingFullScheduleList){
          successFn(self.model.nextCommingFullScheduleList);
        }else{
          RemoteService.getNextFullScheduleList().then(
            function (response) {
              self.model.nextCommingFullScheduleList = response.fullSchedulePeriodDTOs;
              successFn(self.model.nextCommingFullScheduleList);
            },function (error) {
              errorFn(error)
            }
          );
        }
      }

      self.getFullScheduleListForRotationSummary = function(successFn,errorFn){
        if(!!self.model.fullScheduleListForRotationSummary){
          successFn(self.model.fullScheduleListForRotationSummary);
        }else{
          RemoteService.getFullScheduleListForRotationSummary().then(
            function (response) {
              self.model.fullScheduleListForRotationSummary = response.fullSchedulePeriodDTOs;
              successFn(self.model.fullScheduleListForRotationSummary);
            },function (error) {
              errorFn(error)
            }
          );
        }
      }

      self.getClientReportNameByDefaultReportName = function(reportDesign) {

          if(!!self.model.reportParam && !!self.model.reportParam[reportDesign]) {
              return self.model.reportParam[reportDesign];
          }

          return reportDesign;
      }

      self.getAcarsMessageStatusList = function(successFn, errorFn) {
        if(self.model.acarsMessageStatusList === null) {
          RemoteService.getAcarsMessageStatus().then(
                function (response) {
                  self.model.acarsMessageStatusList = response.acarsStatus;
                  successFn(self.model.acarsMessageStatusList);
                },
                function (error) {
                  errorFn(error.msg);
                });
        } else {
          successFn(self.model.acarsMessageStatusList);
        }
      };

        self.getAcarsMessageStatusList = function(successFn, errorFn) {
        	if(self.model.acarsMessageStatusList === null) {
        		RemoteService.getAcarsMessageStatus().then(
	                function (response) {
	                  self.model.acarsMessageStatusList = response.acarsStatus;
	                  successFn(self.model.acarsMessageStatusList);
	                },
	                function (error) {
	                  errorFn(error.msg);
	                });
        	} else {
        		successFn(self.model.acarsMessageStatusList);
        	}
        };

        self.searchExternalTraineeSuggession = function(successFn, errorFn) {
        	RemoteService.searchExternalTraineeSuggession().then(
	           function (response) {
	              successFn(response.externalTraineeSugessions);
	           },
	           function (error) {
	              errorFn(error.msg);
	        });
        };

      self.getNumberOfInitialSearches = function (successFn, errorFn) {
        RemoteService.getNumberOfInitialSearches().then(
          function (response) {
            successFn(response.appParamValueDTO.paramValue);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      };
	self.searchUsersByType = function (param, successFn, errorFn) {
        RemoteService.searchUsersByType(param).then(
          function (response) {
            successFn(response.commonUserDTOS);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      };

      function getMemoCategoriesAdaptor(response) {
          return response.memoCategoryDTOs;
      }

      self.getTrainingRosterExpiryStartDate = function (successFn, errorFn) {
        RemoteService.getTrainingRosterExpiryStartDate().then(
          function (response) {
            successFn(response.appParamValueDTO.paramValue);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      };

      self.getCabinFlightDelayCodes = function (successFn, errorFn) {
        if (self.model.cabinFlightDelayCodes == null) {
          RemoteService.getCabinFlightDelayCodes().then(
            function (response) {
              self.model.cabinFlightDelayCodes = response;
              successFn(self.model.cabinFlightDelayCodes);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        } else {
          successFn(self.model.cabinFlightDelayCodes);
        }
      };

      self.getDutySheetRefreshingTime = function (successFn, errorFn) {
        RemoteService.getDutySheetRefreshingTime().then(
          function (response) {
            successFn(response.appParamValueDTO.paramValue);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      };

      self.getCarrierCode = function (successFn, errorFn) {
        RemoteService.getCarrierCode().then(
          function (response) {
            successFn(response.appParamValueDTO.paramValue);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      };


      (function () {
          RemoteService.loadWeekStartDay().then(
              function (response) {
                  if (response.success) {
                      var dayArr = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
                      self.model.appWeekStartDay = dayArr.indexOf(response.appParamValueDTO.paramValue);
                      applicationConstants.SETTINGS.WEEK_START_DAY = response.appParamValueDTO.paramValue;
                      moment.updateLocale('en', {
                          week: {
                              dow: self.model.appWeekStartDay // sets the first day of the week to moment.
                          }
                      });
                      CommonDataModel.setAppWeekStartDay({firstDay: self.model.appWeekStartDay});
                  }
              },
              function (error) {
            	  console.log("Error in Loading week start days!!");
              }
          );

          self.getBaseAirport(
              function (baseType) {
                  applicationConstants.SETTINGS.CREW_BASE_AIRPORT = baseType;
              }
          );

          RemoteService.getReportParam().then(
              function (response) {
                  if (response.success) {
                      self.model.reportParam = response.reportParam;
                  }
              },
              function (error) {
            	  console.log("Error in Loading Report Params!!");
              }
          );

          RemoteService.getReportServerBaseUrl().then(
              function (response) {
                  self.model.reportBaseUrl = response.baseUrl;
              },function (error) {
            	  console.log("Error in Loading Report Server Base URL!!");
              }
          );

          var carrier = StorageServices.get(StorageServices.KEYS.CARRIER);
          if(carrier === null){
        	  RemoteService.searchCarriers().then(
        	            function (response) {
        	            	StorageServices.set(StorageServices.KEYS.CARRIER,response);
        	            },
        	            function (error) { }
              );
          }

        var carriersList = StorageServices.get(StorageServices.KEYS.CARRIER_LIST);
        if(carriersList === null){
          RemoteService.searchCarriersList().then(
            function (response) {
              StorageServices.set(StorageServices.KEYS.CARRIER_LIST,response);
            },
            function (error) { }
          );
        }

        })();

      self.getCrewTypesForCrewIds = function (crewId,fromdDate,todate, successFn, errorFn) {
        RemoteService.getCrewTypesByIds(crewId,fromdDate,todate).then(
          function (response) {
            successFn(response);
          },
          function (error) {
            //errorFn(error.msg);
          }
        );
      };

      self.getAccessDataToAeroOps = function (successFn, errorFn) {
        RemoteService.navigatesToAeroOps().then(
          function (response) {
            successFn(response);
          },
          function (error) {
            errorFn(error);
          });
      }

      self.searchCarriers = function (successFn, errorFn) {
    	  var carrier = StorageServices.get(StorageServices.KEYS.CARRIER);
    	  if(carrier === null){
    		  RemoteService.searchCarriers().then(
      	            function (response) {
//      	            	self.model.carriers = response;
      	            	StorageServices.set(StorageServices.KEYS.CARRIER,response);
      	            	successFn(response);
      	             },
      	            function (error) { errorFn(error); }
    		  );
          } else {
        	  successFn(carrier);
          }
       }

      self.getManualSplitDutyExtentionStatus = function (successFn, errorFn) {
        var status = StorageServices.get(StorageServices.KEYS.ENABLE_MANUAL_SPLIT_DUTY_EXTENTION);
        if(status === null){
          RemoteService.searchCarriers().then(
            function (response) {
//      	            	self.model.carriers = response;
              StorageServices.set(StorageServices.KEYS.ENABLE_MANUAL_SPLIT_DUTY_EXTENTION,response);
              successFn(response);
            },
            function (error) { errorFn(error); }
          );
        } else {
          successFn(carrier);
        }
      }

      self.searchCarriersList = function (successFn, errorFn) {
        var carriersList = StorageServices.get(StorageServices.KEYS.CARRIER_LIST);
        if(carriersList === null){
          RemoteService.searchCarriersList().then(
            function (response) {
              StorageServices.set(StorageServices.KEYS.CARRIER_LIST,response);
              successFn(response);
            },
            function (error) { errorFn(error); }
          );
        } else {
          successFn(carriersList);
        }
      }

      /**
       * getProgramCodes
       * @param successFn
       * @param errorFn
       */
      self.getProgramCodeList = function (successFn, errorFn) {
        if (self.model.trainingProgramCode === null) {
          RemoteService.getProgramCodeList().then(
            function (response) {
              self.model.trainingProgramCode = response.trainingProgramCodeList;
              successFn(self.model.trainingProgramCode);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        } else {
          successFn(self.model.trainingProgramCode);
        }
      };

      self.getTrainingDescription = function (successFn, errorFn) {
        if (self.model.trainingProgramDesc === null){
          RemoteService.getTrainingDescription().then(
            function (response) {
              self.model.trainingProgramDesc = response.trainingProgramDescList;
              successFn(self.model.trainingProgramDesc);
            },
            function (error) {
              errorFn(error.msg);
            }
          )
        } else {
          successFn(self.model.trainingProgramDesc);
        }
      }

      /**
       * getTrainingLocations
       * @param successFn
       * @param errorFn
       */
      self.getTrainingLocationList = function (successFn, errorFn) {
        if (self.model.trainingLocations === null) {
          RemoteService.getTrainingLocationList().then(
            function (response) {
              self.model.trainingLocations = response.locationList;
              successFn(self.model.trainingLocations);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        } else {
          successFn(self.model.trainingLocations);
        }
      };

      /**
       * getTraineeList
       * @param successFn
       * @param errorFn
       */
      self.getTraineeList = function (successFn, errorFn) {
        if (self.model.traineesList === null) {
          RemoteService.getTraineeList().then(
            function (response) {
              self.model.traineesList = response.trainerOrTraineeList;
              successFn(self.model.traineesList);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        } else {
          successFn(self.model.traineesList);
        }
      };

      /**
       * getTrainerList
       * @param successFn
       * @param errorFn
       */
      self.getTrainerList = function (successFn, errorFn) {
        if (self.model.trainersList === null) {
          RemoteService.getTrainerList().then(
            function (response) {
              self.model.trainersList = response.trainerOrTraineeList;
              successFn(self.model.trainersList);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        } else {
          successFn(self.model.trainersList);
        }
      };

      /**
       * common dropdownList
       * @param successFn
       * @param errorFn
       */
      self.getDropDownList = function (dropdownId, tenant, successFn, errorFn) {
        if (self.model.dropdownList === null) {
          RemoteService.getDropDownList(dropdownId, tenant).then(
            function (response) {
              self.model.dropdownList = response;
              successFn(self.model.dropdownList);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        } else {
          successFn(self.model.dropdownList);
        }
      };

      self.getPrintGdHubs = function (successFn, errorFn) {
        if (self.model.gdCarriersList === null) {
                      RemoteService.searchCarriersList().then(
                          function (response) {
                              self.model.gdCarriersList = response;
                              successFn(self.model.gdCarriersList);
                          },
                          function (error) {
                              errorFn(error.msg);
                          }
                      );
        } else {
                      successFn(self.model.gdCarriersList);
        }

      };

      self.getCrewDesignationList = function (successFn, errorFn) {
          if (self.model.crewDesignationList === null) {
              RemoteService.getCrewDesignations().then(
                  function (response) {
                      self.model.crewDesignationList = response.crewDesignations;
                      successFn(self.model.crewDesignationList);
                  },
                  function (error) { errorFn(error.msg); }
              );
          } else {
              successFn(self.model.crewDesignationList);
          }
      };

      self.getDepartments = function (successFn, errorFn) {
        if (self.model.crewDesignationList === null) {
          RemoteService.getDepartments().then(
            function (response) {
              self.model.departmentList = response.deparmentDTOs;
              successFn(self.model.departmentList);
            },
            function (error) { errorFn(error.msg); }
          );
        } else {
          successFn(self.model.departmentList);
        }
      };

    }
}());
